export const enum PhoneticType {
	PINYIN,
	ZHUYIN
}